 
const Container = ({children}) => (
    <div className="container mx-auto bg-gray-200 p-10 mb-6">{children}</div>
  );
  
  export default  Container;